import React from "react"


function ErrorPage(){
    return (
      <div>
        <h1>Error</h1>
      </div>
    )
}

export default ErrorPage